import React, { useEffect, useState } from "react";
import logo1 from "../images/logo1.png";

export default function NavTop() {
  const [ShowNav, setShowNav] = useState(false);

  useEffect(() => {
    if (ShowNav) {
      // Desactivar scroll
      document.body.style.overflow = "hidden";
    } else {
      // Activar scroll
      document.body.style.overflow = "unset";
    }
  }, [ShowNav]);

  const redireccionar = (id) => {
    const elemento = document.getElementById(id);
    console.log(elemento);
    if (elemento) {
      elemento.scrollIntoView({ behavior: "smooth" });
    }
    setShowNav(false);
  };
  return (
    <>
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <img src={logo1} alt="logo" className="logo-1" />

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => (ShowNav ? setShowNav(false) : setShowNav(true))}
          >
            <span className="fas fa-bars"></span>
          </button>
          <div
            className={
              ShowNav
                ? "collapse navbar-collapse show"
                : "collapse navbar-collapse"
            }
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <button
                  className="nav-link"
                  href=""
                  onClick={() => redireccionar("home")}
                >
                  Inicio
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link"
                  onClick={() => redireccionar("about")}
                >
                  Acerca de
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link"
                  onClick={() => redireccionar("ventaja")}
                >
                  Ventajas
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link"
                  onClick={() => redireccionar("team")}
                >
                  Equipo
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link"
                  onClick={() => redireccionar("test")}
                >
                  Testimonios
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link"
                  onClick={() => redireccionar("duda")}
                >
                  Dudas
                </button>
              </li>
              <li className="nav-item">
                <button
                  className="nav-link"
                  onClick={() => redireccionar("contact")}
                >
                  Contáctanos
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
